module.exports = __webpack_public_path__ + "img/gs.b272da02.png";